<!--
 * @Author: your name
 * @Date: 2022-03-12 15:31:47
 * @LastEditTime: 2022-12-29 10:04:29
 * @LastEditors: changfangyuan changfangyuan@sic.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \huangshi_door\src\views\pcm\NoApply.vue
-->
<template>
  <div class="ExemptReview">
    <div class="main-width m_t20">
      <!-- <div class="form-block">
        <Marquee @default="getData(0)" @search="clickMarquee" />
      </div> -->
      <!-- 省市区部门级联 -->
      <!--<div class="policy-nav">
        <div class="policy-nav-item">
          <span>选择区划</span>
          <ul>
            <li
              v-for="(item, index) in cityArr"
              :key="index"
              @click="selectCity(item)"
              :class="currentCity === item.id ? 'is-active' : ''"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>-->
      <div class="header-radio">
        <div class="title">
          <div class="address">
            <div
              :class="[index === active ? 'active' : '', item ? 'btn' : '']"
              v-for="(item, index) in btnList"
              :key="index"
              @click="
                current = index;
                handleClickBtn(index);
              "
            >
              {{ item.label }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="active == 0">
        <div class="form-search">
          <div class="form-search-left">
            <!-- <span>无申请兑现</span> -->
            <el-input v-model="input" placeholder="输入标题或关键词" />
            <el-button type="primary" @click="search">查询</el-button>
          </div>
          <!-- <el-tabs
            v-model="activeName"
            class="form-search-right"
            @tab-click="handleClick"
          >
            <el-tab-pane label="最新政策" name="create_time" />
            <el-tab-pane label="兑现截止日期" name="closing_time" />
            <el-tab-pane label="奖励金额" name="amount" />
          </el-tabs> -->
        </div>
        <div class="table">
          <el-table
              :data="tableData"
              style="width: 100%"
              :show-header="false"
              :show-pagination="true"
          >
            <el-table-column prop="date" label="日期">
              <template slot-scope="scope">
                <div class="item item-center">
                  <div class="left-box">
                    <div class="title-box">
                      <el-tag
                          size="mini"
                          v-if="statusTag(scope.row) == '申请中'"
                      >{{ statusTag(scope.row) }}</el-tag
                      >
<!--                      <el-tag-->
<!--                          size="mini"-->
<!--                          type="info"-->
<!--                          v-if="statusTag(scope.row) == '未开始'"-->
<!--                      >{{ statusTag(scope.row) }}</el-tag-->
<!--                      >-->
<!--                      <el-tag-->
<!--                          size="mini"-->
<!--                          type="danger"-->
<!--                          v-if="statusTag(scope.row) == '已截止'"-->
<!--                      >{{ statusTag(scope.row) }}</el-tag-->
<!--                      >-->
                      <div class="tit font-16">
                        &nbsp;&nbsp;{{ scope.row.name }}
                      </div>
                    </div>
                    <div class="type-box">
                      <img
                          class="item-icon"
                          src="@/assets/images/icon/noapply/type_icon.png"
                      />
                      <div class="text">政策类型：{{ scope.row.nature }}</div>
                      <img
                          class="item-icon m_l16"
                          src="@/assets/images/icon/noapply/dept_icon.png"
                      />
                      <div class="text">
                        发布部门：{{ scope.row.dicTranslate.departmentId }}
                      </div>
                    </div>
                    <div class="time-box">
                      <img
                          class="item-icon"
                          src="@/assets/images/icon/noapply/date_icon.png"
                      />
                      <div class="text">
                        兑现日期：{{ scope.row.releaseTime }}至{{
                          scope.row.closingTime
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="right-box">
                    <div class="amount-box">
                      <div class="content-html" v-html="scope.row.content" @click="dxbz(scope.row)">政策内容：</div>
                      <div class="contacts-item">
                        <span>
                          <i class="el-icon-user"></i>
                          联系人：{{ scope.row.contacts && scope.row.contacts != 0 ? scope.row.contacts: "--" }}</span
                        >
                        <span>
                          <i class="el-icon-phone"></i>
                          联系电话：{{ scope.row.contactsPhone && scope.row.contacts != 0 ? scope.row.contactsPhone: "--" }}</span
                        >
                      </div>
                    </div>
                    <div class="btn-box">

                      <div class="btns">
                        <button type="button" class="el-button el-button--text">
                          <span>
<!--                            <a @click="goPolicy(scope.row.policyId)">政策依据</a>-->
                            <a @click="zcyjAlert(scope.row)">政策依据</a>
                          </span>
                        </button>
                      </div>
					  <div class="btn">
					  		 <button type="button" class="el-button el-button--text">
					  			<span>
					               <a @click="goPolicyGuidelines(scope.row)">政策指南</a>
					  			</span>
					  		</button>
					  </div>
                    </div>
                  </div>
                </div>
                <div class="cash-policy-scroll" v-if="scope.row.scrollDataList&&scope.row.scrollDataList.length>0">
                  <vue-seamless-scroll :data="scope.row.scrollDataList" :class-option="classCashOption" class="seamless-wrap">
                    <ul class="items-data">
                      <li v-for="item in scope.row.scrollDataList"><span>企业名称：{{item.companyName}}</span><span>兑现金额：{{item.amount}}</span></li>
                    </ul>
                  </vue-seamless-scroll>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="center-block tc m_t45" v-if="total3>0">
            <Pagination
                :total="total3"
                :pages="pages3"
                :currentPageSize="size3"
                :currentPage="current3"
                @currentChange="currentChange3"
            />
          </div>
        </div>
      </div>
<!--      <div v-if="active == 1">-->
<!--        <div class="form-search">-->
<!--          <div class="form-search-left">-->
<!--            &lt;!&ndash; <span>无申请兑现</span> &ndash;&gt;-->
<!--            <el-input v-model="input" placeholder="输入标题或关键词" />-->
<!--            <el-button type="primary" @click="search">查询</el-button>-->
<!--          </div>-->
<!--          &lt;!&ndash; <el-tabs-->
<!--            v-model="activeName"-->
<!--            class="form-search-right"-->
<!--            @tab-click="handleClick"-->
<!--          >-->
<!--            <el-tab-pane label="最新政策" name="create_time" />-->
<!--            <el-tab-pane label="兑现截止日期" name="closing_time" />-->
<!--            <el-tab-pane label="奖励金额" name="amount" />-->
<!--          </el-tabs> &ndash;&gt;-->
<!--        </div>-->
<!--        <div class="table">-->
<!--          <el-table-->
<!--            :data="tableData"-->
<!--            style="width: 100%"-->
<!--            :show-header="false"-->
<!--            :show-pagination="true"-->
<!--          >-->
<!--            <el-table-column prop="date" label="日期">-->
<!--              <template slot-scope="scope">-->
<!--                <div class="item item-center">-->
<!--                  <div class="left-box">-->
<!--                    <div class="title-box">-->
<!--                      &lt;!&ndash; <img-->
<!--                        :src="-->
<!--                          require('@/assets/images/icon/noapply/doing_icon.png')-->
<!--                        "-->
<!--                        class="status-icon"-->
<!--                      /> &ndash;&gt;-->
<!--                      <el-tag-->
<!--                        size="mini"-->
<!--                        v-if="statusTag(scope.row) == '申请中'"-->
<!--                        >{{ statusTag(scope.row) }}</el-tag-->
<!--                      >-->
<!--                      <el-tag-->
<!--                        size="mini"-->
<!--                        type="info"-->
<!--                        v-if="statusTag(scope.row) == '未开始'"-->
<!--                        >{{ statusTag(scope.row) }}</el-tag-->
<!--                      >-->
<!--                      <el-tag-->
<!--                        size="mini"-->
<!--                        type="danger"-->
<!--                        v-if="statusTag(scope.row) == '已截止'"-->
<!--                        >{{ statusTag(scope.row) }}</el-tag-->
<!--                      >-->
<!--                      <div class="tit font-16">-->
<!--                        &nbsp;&nbsp;{{ scope.row.name }}-->
<!--                      </div>-->
<!--                      &lt;!&ndash; new  兑现日期 和当前日期 相差2 天的&ndash;&gt;-->
<!--                      &lt;!&ndash; <img-->
<!--                        class="new_icon"-->
<!--                        src="@/assets/images/icon/noapply/new_icon.png"-->
<!--                      /> &ndash;&gt;-->
<!--                    </div>-->
<!--                    <div class="type-box">-->
<!--                      <img-->
<!--                        class="item-icon"-->
<!--                        src="@/assets/images/icon/noapply/type_icon.png"-->
<!--                      />-->
<!--                      <div class="text">政策类型：{{ scope.row.nature }}</div>-->
<!--                      <img-->
<!--                        class="item-icon m_l16"-->
<!--                        src="@/assets/images/icon/noapply/dept_icon.png"-->
<!--                      />-->
<!--                      <div class="text">-->
<!--                        发布部门：{{ scope.row.dicTranslate.departmentId }}-->
<!--                      </div>-->
<!--                    </div>-->
<!--                    <div class="time-box">-->
<!--                      <img-->
<!--                        class="item-icon"-->
<!--                        src="@/assets/images/icon/noapply/date_icon.png"-->
<!--                      />-->
<!--                      <div class="text">-->
<!--                        兑现日期：{{ scope.row.releaseTime }}至{{-->
<!--                          scope.row.closingTime-->
<!--                        }}-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="right-box">-->
<!--                    <div class="amount-box">-->
<!--                      &lt;!&ndash; <div class="lin_60">-->
<!--                        <span class="fs_28 numText">-->
<!--                          {{-->
<!--                            scope.row.statistics-->
<!--                              ? scope.row.statistics.fulfillCount-->
<!--                              : "&#45;&#45;"-->
<!--                          }}-->
<!--                        </span>-->
<!--                        <span class="unit">家</span>-->
<!--                      </div>-->
<!--                      <div class="label">-->
<!--                        {{-->
<!--                          scope.row.isFunding == 1 ? "已兑现企业" : "已无感兑现"-->
<!--                        }}-->
<!--                      </div> &ndash;&gt;-->
<!--                      <div-->
<!--                        class="content-html"-->
<!--                        v-html="scope.row.standard"-->
<!--                        @click="dxbz(scope.row)"-->
<!--                      ></div>-->
<!--                      <div class="contacts-item">-->
<!--                        <span>-->
<!--                          <i class="el-icon-user"></i>-->
<!--                          联系人：{{ scope.row.contacts && scope.row.contacts != 0 ? scope.row.contacts: "&#45;&#45;" }}</span-->
<!--                        >-->
<!--                        <span>-->
<!--                          <i class="el-icon-phone"></i>-->
<!--                          联系电话：{{ scope.row.contactsPhone && scope.row.contacts != 0 ? scope.row.contactsPhone: "&#45;&#45;" }}</span-->
<!--                        >-->
<!--                      </div>-->
<!--                    </div>-->

<!--                    &lt;!&ndash; <div class="date-box" v-if="scope.row.isFunding == 1">-->
<!--                      <div class="lin_60">-->
<!--                        <span class="fs_28 numText">-->
<!--                          {{-->
<!--                            scope.row.statistics-->
<!--                              ? scope.row.statistics.amountCount-->
<!--                              : "&#45;&#45;"-->
<!--                          }}-->
<!--                        </span>-->
<!--                        <span class="unit">元</span>-->
<!--                      </div>-->
<!--                      <div class="label">已兑现总金额</div>-->
<!--                    </div> &ndash;&gt;-->
<!--                    <div class="btn-box">-->
<!--                      <div class="btn">-->
<!--                        &lt;!&ndash; <el-button-->
<!--                          class="el-button el-button&#45;&#45;primary"-->
<!--                          :type="renderButton(scope.row).type"-->
<!--                          :disabled="renderButton(scope.row).disabled"-->
<!--                          @click="sureDx(scope.row)"-->
<!--                        >-->

<!--                          <span>-->
<!--                            {{ renderButton(scope.row).label }}-->
<!--                          </span>-->
<!--                        </el-button> &ndash;&gt;-->
<!--                        &lt;!&ndash; <span-->
<!--                          >已兑现企业-->
<!--                          <i class="red-text">{{-->
<!--                            scope.row.statistics-->
<!--                              ? scope.row.statistics.fulfillCount-->
<!--                              : "&#45;&#45;"-->
<!--                          }}</i>-->
<!--                          家</span-->
<!--                        >-->
<!--                        <span-->
<!--                          >已兑现总金额<i class="red-text">{{-->
<!--                            scope.row.statistics-->
<!--                              ? scope.row.statistics.amountCount-->
<!--                              : "&#45;&#45;"-->
<!--                          }}</i-->
<!--                          >元</span-->
<!--                        > &ndash;&gt;-->
<!--                      </div>-->
<!--                      &lt;!&ndash; <div class="red-text">-->
<!--                        {{ renderButton(scope.row).tip }}-->
<!--                      </div> &ndash;&gt;-->
<!--                      <div class="btns">-->
<!--                        &lt;!&ndash; <button-->
<!--                          type="button"-->
<!--                          class="el-button el-button&#45;&#45;text"-->
<!--                          @click="dxbz(scope.row)"-->
<!--                        >-->
<!--                          <span>兑现标准</span>-->
<!--                        </button> &ndash;&gt;-->
<!--                        <button type="button" class="el-button el-button&#45;&#45;text">-->
<!--                          <span>-->
<!--                            <a @click="goPolicy(scope.row.policyId)">-->
<!--                              政策依据-->
<!--                            </a>-->
<!--                          </span>-->
<!--                        </button>-->
<!--                        &lt;!&ndash; -->
<!--                        <button-->
<!--                          type="button"-->
<!--                          @click="toInquiry"-->
<!--                          class="el-button el-button&#45;&#45;text"-->
<!--                        >-->
<!--                          <span>我要咨询</span>-->
<!--                        </button> &ndash;&gt;-->
<!--                      </div>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="cash-policy-scroll" v-if="scope.row.scrollDataList&&scope.row.scrollDataList.length>0">-->
<!--                  <vue-seamless-scroll :data="scope.row.scrollDataList" :class-option="classCashOption" class="seamless-wrap">-->
<!--                    <ul class="items-data">-->
<!--                      <li v-for="item in scope.row.scrollDataList"><span>企业名称：{{item.companyName}}</span><span>兑现金额：{{item.amount}}</span></li>-->
<!--                    </ul>-->
<!--                  </vue-seamless-scroll>-->
<!--                </div>-->
<!--              </template>-->
<!--            </el-table-column>-->
<!--          </el-table>-->
<!--          <div class="center-block tc m_t45" v-if="total3>0">-->
<!--            <Pagination-->
<!--              :total="total3"-->
<!--              :pages="pages3"-->
<!--              :currentPageSize="size3"-->
<!--              :currentPage="current3"-->
<!--              @currentChange="currentChange3"-->
<!--            />-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div v-else-if="active == 0" class="iframe-div">-->
<!--        &lt;!&ndash; <iframe :src="src" ref="iframe" class="iframe-container"></iframe> &ndash;&gt;-->
<!--        <el-card class="box-card">-->
<!--          <div slot="header" class="clearfix">-->
<!--            <p class="top-center">-->
<!--              黄石市坚持以纾困惠企加速元气恢复，提振信心稳定预期，促进企业健康平稳发展，2020年-2022年间，共计落实惠企政策134项，兑现资金达7.93亿元。-->
<!--              2020年，黄石市聚焦市场主体“活下来”，制定87条对接中央一揽子支持政策清单，出台“黄金33条”，发放稳岗补贴9929万元，减税降费21.58亿元。-->
<!--              2021年，黄石市实施惠企政策“无申请兑现”，兑付资金5160万元。深入推进“清减降”专项行动，新增减税降费8.4亿元。-->
<!--              2022年以来，市政府出台《关于更大力度对受疫情影响市场主体进行纾困解难的若干措施》《黄石市贯彻落实省进一步激发市场活力稳住经济增长的若干措施工作清单》等一系列政策文件，截至第三季度末，无申请兑现”累计拨付惠企资金5.7亿元，增值税留抵退税31.72亿元，办理“六税两费”减免1.24亿元，全市新登记市场主体8.8万户，同比增长3.4倍。-->
<!--            </p>-->
<!--          </div>-->
<!--          <h3 style="text-align: center">惠企政策兑现情况</h3>-->
<!--          <div id="echartsBar" ref="echartsBar"></div>-->
<!--          <div class="policy-cash-list" v-if="publicyData.length">-->
<!--            <ul class="scroll-list-th">-->
<!--              <li>-->
<!--                <span>政策</span>-->
<!--                <span>企业名称</span>-->
<!--                <span>部门</span>-->
<!--                <span>金额（元）</span>-->
<!--              </li>-->
<!--            </ul>-->
<!--            <div class="policy-scroll">-->
<!--              <vue-seamless-scroll :data="publicyData" :class-option="classOption" class="seamless-wrap">-->
<!--                <ul class="items-data">-->
<!--                  <li v-for="item in publicyData">-->
<!--                    <span>{{item.name}}</span>-->
<!--                    <span>{{item.companyName}}</span>-->
<!--                    <span>{{item.deptName}}</span>-->
<!--                    <span>{{item.price}}</span>-->
<!--                   </li>-->
<!--                </ul>-->
<!--              </vue-seamless-scroll>-->
<!--            </div>-->
<!--          </div>-->
<!--        </el-card>-->
<!--      </div>-->
      <Apply v-show="active == 2"></Apply>
      <ToolList v-show="active == 1"></ToolList>
      <!-- 数据采集使用授权 -->
      <el-dialog class="dialog" :visible.sync="dialogShow" width="70%">
        <h3>数据采集使用授权</h3>
        <div>
          为维护授权企业合法权益，请在在授权委托书前，仔细阅读各条款，了解授权企业在本授权的权利、义务。
        </div>
        <div>
          一、授权企业采集本企业如下信息：
          <p>
            （一）企业基本信息、经营信息、财务信息、税务信息、金融信息、水电气信息、各类负面信息等企业向相关部门和单位提供的及相关部门和单位在履职、提供服务中产生的信息；
          </p>
          <p>（二）企业的董事、监事、高级管理人员与其履行职务相关的信息；</p>
          <p>
            （三）国家法律、行政法规、部门规章、地方性法规未禁止采集的与授权企业有关的其他信息。
          </p>
        </div>
        <div>
          二、授权企业在此授权采集方可以从国家机关、政府部门、事业单位、金融机构等相关部门和单位采集上述信息（包括所有历史信息及更新信息），也可从行业协会、社会团体、互联网信息平台渠道、第三方机构等取得上述信息。授权企业在此授权上述有关部门和单位向采集方提供本企业上述信息。
        </div>
        <div>
          三、授权企业在此承诺国家机关、政府部门、事业单位等部门和单位因行政管理、公共服务的需要，可以直接查询企业的上述信息，采集方可向上述部门和单位提供上述信息。
        </div>
        <div>
          四、授权企业同意授权有效期自授权企业确认本授权承诺之日起至被授权人相关所有业务终结之日止。
        </div>
        <div>
          五、本授权自授权签订之日起生效，信息采集期限为长期，以授权企业提交授权书之日为授权生效日。
        </div>
        <div>
          六、如需终止本授权，授权企业需提供相关资料，满足终止授权条件的可以终止。
        </div>
        <div>
          七、授权企业在此声明已知悉并理解本授权，以及因采集和提供非公开信息及负面信息可能导致的任何不利后果。
        </div>
        <div>
          八、若本企业与被授权人发生纠纷，应友好协商，协商不成提交仲裁委员会仲裁解决
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="empower" type="primary">授权</el-button>
          <el-button @click="dialogShow = false" type="primary">拒绝</el-button>
        </span>
      </el-dialog>
    </div>
    <div
      class="inquiry-modal"
      style="width: 730px; height: 600px"
      v-show="modelShow"
    >
      <i class="el-icon-close" @click="closeInquiryModal"></i>
      <iframe
        width="730"
        height="600"
        class="iframe_box"
        src="https://chatbot.aliyuncs.com/intl/index.htm?from=XDFVWftBmG"
      ></iframe>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { pageList, dataPageList, cashScrollList } from "@/api/noApply";
import { DateDiff } from "@/toolUtil/common";
import Marquee from "@/components/semantics/Marquee.vue";
import Pagination from "@components/base/pagination/PcmPagination.vue";
import Apply from "./Apply.vue";
import ToolList from "./toolList.vue";
import cookie from "js-cookie";

export default {
  name: "ExemptReview",
  components: { Marquee, Apply, ToolList, Pagination },
  data() {
    return {
      value1: "",
      value2: "",
      // active是btnList的index
      btnList: [
        // {
        //   label: "惠企兑现概要",
        //   value: "惠企兑现概要",
        // },
        // {
        //   label: "无申请兑现",
        //   value: "无申请兑现",
        // },
        // {
        //   label: "政策申请",
        //   value: "政策申请",
        // },
        {
          label: "政策项目",
          value: "政策项目",
        },
        {
          label: "政策工具",
          value: "政策工具",
        }
		// ,
		// {
		//   label: "政策指南",
		//   value: "政策指南",
		// }
      ],
      active: this.$route.query.index ? Number(this.$route.query.index) : 0,
      src: "http://dcrt.huangshi.gov.cn/#/fp",
      formData: [
        {
          selected: "全部",
          label: "选择部门：",
          arr: [
            {
              value: null,
              label: "全部",
            },
          ],
        },
        {
          selected: "全部",
          label: "政策类型：",
          arr: [
            {
              value: null,
              label: "全部",
            },
            {
              value: "认定奖励(45)",
              label: "认定奖励(45)",
            },
            {
              value: "资金补助(23)",
              label: "资金补助(23)",
            },
            {
              value: "竞赛评选(17)",
              label: "竞赛评选(17)",
            },
          ],
        },
        {
          selected: "全部",
          label: "申报状态：",
          arr: [
            {
              value: null,
              label: "全部",
            },
            {
              value: "兑现中",
              label: "兑现中",
            },
            {
              value: "已截止",
              label: "已截止",
            },
            {
              value: "未开始",
              label: "未开始",
            },
          ],
        },
      ],
      input: "",
      activeName: "create_time",
      tableData: [],
      total3: 0,
      pages3: 0,
      current3: 1,
      size3: 0,
      dialogShow: false,
      modelShow: false,
      areaOption: this.$root.$data.areaOption,
      current_option: {},
      currentItem: {},
      cityArr: [
        {
          id: "420200",
          name: "黄石市",
        },
        // {
        //   id: "420281",
        //   name: "大冶市",
        // },
        // {
        //   id: "420222",
        //   name: "阳新县",
        // },
      ],
      currentCity: "420200",
      publicyData: [],
    };
  },
  computed: {
    ...mapGetters(["city", "roleSave", "loginState"]),
    classOption() {
      return {
        step: 0.7
      }
    },
    classCashOption(){
      return {
        step: 0.5
      }
    }
  },

  created() {
    // 无申请兑现计算截止倒计时
    this.tableData = this.tableData.map((item) => {
      item.day = DateDiff(new Date(), new Date(item.closingDate));
      return item;
    });
    this.getData(0);
    this.getDataList()
  },
  mounted() {
    let vm = this;
    if(vm.$refs.echartsBar){
      vm.$nextTick(()=>{
        vm.echartsBar();
      })
    }

  },
  methods: {
    echartsBar() {
      var myChart = this.$echarts.init(document.getElementById("echartsBar"));
      let option = {
        calculable: true,
        tooltip: {
          show: true,
        },
        legend: {
          //   指示框名字  注意！要和下方series中的name一起改
          data: ["兑现政策数", "兑现金额(亿元)"],
          // 指示框位置  距离上下左右多少
          right: "center",
          // top: "3%",
          textStyle: {
            color: "#4F4F4F", //字体颜色
          },
        },
        xAxis: [
          {
            type: "category",
            data: ["2020年", "2021年", "2022年"],
            axisLine: {
              //x轴线的颜色以及宽度
              show: true, //是否显示X轴点啊
              lineStyle: {
                color: "#e2e2e2",
              },
            },
            axisLabel: {
              textStyle: {
                color: "#333", //坐标值得具体的颜色
              },
            },
            axisTick: {
              //是否显示刻度线
              show: false,
            },
          },
        ],
        yAxis: [
          {
            name: "兑现政策（项）",
            type: "value",
            max: 100,
            axisTick: {
              //y轴刻度线
              show: false,
            },
            axisLine: {
              show: false, // Y轴
            },
            axisLabel: {
              textStyle: {
                color: "#333", //坐标值得具体的颜色
              },
            },
            splitLine: {
              // 表格里面Y轴线条
              show: true,
              lineStyle: {
                type: "dashed", //虚线
                color: "#e2e2e2", //虚线颜色
              },
            },
          },
          {
            name: "兑现金额（亿元）",
            type: "value",
            axisTick: {
              //y轴刻度线
              show: false,
            },
            axisLine: {
              show: false, // Y轴
            },
            axisLabel: {
              textStyle: {
                color: "#333", //坐标值得具体的颜色
              },
            },
          },
        ],
        // 整体大小
        grid: {
          left: "3%",
          right: "4%",
          top: "10%",
          bottom: "5%",
          containLabel: true,
        },
        series: [
          {
            barGap: 2,
            barWidth: "7%", //柱子宽度
            name: "兑现政策数",
            type: "bar",
            data: [34, 41, 59],
            itemStyle: {
              //颜色样式部分
              normal: {
                barBorderRadius: [20, 20, 0, 0], //圆角[上左，上右，下右，下左]
                label: {
                  show: true, //开启数字显示
                  position: "top", //在上方显示数字
                  textStyle: {
                    //数值样式
                    color: "#474646", //字体颜色
                    fontSize: 10, //字体大小
                  },
                  formatter: (params) => {
                    return params.value + "项";
                  },
                },
                //   柱状图颜色渐变
                color: "#73A0FA",
              },
            },
            yAxisIndex: 0,
          },
          {
            barWidth: "7%", //柱子宽度
            name: "兑现金额(亿元)",
            type: "bar",
            data: [1.86, 2.02, 4.05],
            itemStyle: {
              //颜色样式部分
              normal: {
                barBorderRadius: [20, 20, 0, 0], //圆角[上左，上右，下右，下左]
                label: {
                  show: true, //开启数字显示
                  position: "top", //在上方显示数字
                  textStyle: {
                    //数值样式
                    color: "#474646", //字体颜色
                    fontSize: 10, //字体大小
                  },
                  formatter: (params) => {
                    return params.value + "亿元";
                  },
                },
                //   柱状图颜色渐变
                color: "#017CE4",
              },
            },
            yAxisIndex: 1,
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
    /*selectCity(options) {
      options.addressCode ? options.id : this.city.id;
      this.current_option = {
        addressCode: options.id,
      };
      this.currentCity = options.id;
      this.getData(1);
    },*/
    statusTag(item) {
      const { declarationStatus } = item;
      let dicStatus = {
        START: "申请中",
        STOP: "已截止",
        NOTSTART: "未开始",
      };
      return dicStatus[declarationStatus];
    },
    renderButton(item) {
      const { declarationStatus, isCanFulfill, isFulfill } = item;
      const renturnData = {
        type: "info",
        disabled: true,
        label: "兑现已截止",
        tip: "",
      };
      if (declarationStatus === "START") {
        renturnData.label = "确认兑现";
        if (cookie.get("accessToken")) {
          //已登录
          if (this.roleSave == 1) {
            //已认证
            if (isCanFulfill == 1) {
              if (isFulfill == 1) {
                renturnData.label = "已申请";
              } else {
                renturnData.type = "primary";
                renturnData.disabled = false;
              }
            } else {
              renturnData.type = "primary";
              renturnData.tip = "暂无兑现资格";
            }
          } else {
            //未认证
            renturnData.type = "primary";
            renturnData.tip = "未实名认证";
          }
        } else {
          renturnData.disabled = false;
        }
      } else {
        renturnData.label =
          declarationStatus === "STOP" ? "兑现已截止" : "未开始兑现";
      }

      return renturnData;
    },
    /*handleClick() {
      this.current3 = 1;
      this.getData(0);
    },*/
    handleClickBtn(index) {
      this.active = index;
      /*     if (index == 3) {
        location.href =
          "https://book.yunzhan365.com/nqtou/yzvv/mobile/index.html";
      } else  */
      if (index == 1) {
        this.current3 = 1;
        this.getData(0);
      } else if(index == 0){
        this.$nextTick(() => {
          this.echartsBar();
        });
      }
    },
    toThousands(num) {
      if (num == 0) {
        return "--";
      }
      var num = (num || 0).toString(),
        result = "";
      // 将传入数据转换为字符串
      while (num.length > 3) {
        // 只要字符串长度大于三就执行
        result = "," + num.slice(-3) + result;
        // 将字符串后三位裁剪并加入最终的字符串
        num = num.slice(0, num.length - 3);
        // 更新字符串长度
      }
      if (num) {
        result = num + result;
      }
      return result;
    },
    getDataList() {
      dataPageList({
        pageNumber: 1,
        pageSize: 100
      }).then(res=>{
        this.publicyData = res.data.result.records
      })
    },
    async getData(type) {
      // 0-default|1-search
      this.loading = true;
      let options = {
        pageNumber: this.current3,
        pageSize: this.size3,
        order: "desc",
        orderBy: this.activeName,
        // addressCode: this.city.locationAddressCode,
      };
      if (type === 1) {
        options = {
          ...options,
          ...this.current_option,
        };
      }
      if (!this.city.locationAddressCode) {
        options.addressCode = this.city.id;
      }
      let res0 = await pageList(options);
      /*pageList(options)
        .then((res) => {

        })
        .finally(() => (this.loading = false));*/
      let { code, result, msg } = res0.data;
      if (code === 200) {
        const { total, list, pages } = result;

        let getCashData = list.map(async (item) => {
          const getDataList = await this.getCashScrollListData(item.id)
          item.scrollDataList = getDataList
          return item;
        });
        this.tableData = await Promise.all(getCashData)
        this.total3 = total;
        this.pages3 = pages;
      }
    },
    async getCashScrollListData(id) {
      const res = await cashScrollList({pageNumber: 1,pageSize: 10, id})
      let getData = []
      if(res.data.success){
        getData = res.data.result.records
      }
      if(getData && getData.length>0)
      return getData
    },
    search() {
      this.current3 = 1;
      const filterOptions = {
        name: this.input,
      };
      this.current_option = {
        ...this.current_option,
        ...filterOptions,
      };
      this.getData(1);
    },
    clickMarquee(options) {
      options.addressCode ? options.addressCode : this.city.id;
      this.current_option = {
        addressCode: options.addressCode,
        departmentId: options.departmentId,
        nature: options.nature,
      };
      this.getData(1);
    },
    currentChange3(params) {
      this.current3 = params;
      this.getData(1);
    },
    // 兑现日期 和当前日期 相差2 天的
    checkNew(item) {
      let nowTime = new Date();
      const currentDate =
        nowTime.getFullYear() +
        "-" +
        (nowTime.getMonth() + 1) +
        "-" +
        nowTime.getDate();
      return (
        (getDaysBetween(currentDate, item.releaseTime) >= 0 &&
          getDaysBetween(currentDate, item.releaseTime) <= 2) ||
        (getDaysBetween(item.releaseTime, currentDate) >= 0 &&
          getDaysBetween(item.releaseTime, currentDate) <= 2)
      );
    },
    empower() {
      this.dialogShow = false;
      this.$message({
        message: "授权成功",
        type: "success",
      });
      setTimeout(() => {
        this.$router.push({
          name: "ErDetails",
          query: {
            id: this.currentItem.id,
          },
        });
      }, 1000);
    },
    sureDx(item) {
      if (cookie.get("accessToken")) {
        // this.dialogShow = true;
        this.currentItem = item;
        this.$router.push({
          name: "ErDetails",
          query: {
            id: item.id,
          },
        });
      } else {
        this.$message({
          message: "请先登录",
          type: "warning",
        });
      }
    },
    //政策内容弹窗
    dxbz(item) {
      this.$alert(item.content, "政策内容", {
        dangerouslyUseHTMLString: true,
      });
    },
    //政策依据弹窗
    zcyjAlert(item) {
      this.$alert(item.policyBasis, "政策依据", {
        dangerouslyUseHTMLString: true,
      });
    },
    toInquiry() {
      this.modelShow = true;
    },
    closeInquiryModal() {
      this.modelShow = false;
    },
    goPolicy(policyId) {
      const { href } = this.$router.resolve({
        path: "/pcm/policyDetail",
        query: { publicyId: policyId },
      });
      window.open(href, "_blank");
    },
	goPolicyGuidelines(row) {
	  this.$router.push({
	    path: "/detail/policyGuidelines",
	    query: {
			name: row.name,
			content: row.content,
			declareStandard: row.declareStandard,
			cashProcessFile: row.cashProcessFile,
			contacts: row.contacts,
			contactsPhone: row.contactsPhone,
			address: row.dicTranslate.addressCode,
			departmentName: row.dicTranslate.departmentId,
			releaseTime: row.releaseTime,
			closingTime: row.closingTime
		},
	  });
	},
  },
};
</script>
<style lang="scss">
@import "@/assets/styles/components/table.scss";
.el-message-box__wrapper{
  .el-message-box{
    width: 40% !important;
    .el-message-box__content{
      max-height: 300px;
      overflow: auto;
    }
  }
}
.ExemptReview{
 /* .el-button--primary.is-disabled {
    color: #fff;
    background-color: #4988df;
    border-color: #4988df;
  }
  .el-button--info.is-disabled {
    color: #fff;
    background-color: #c8c9cc;
    border-color: #c8c9cc;
  }*/
  .header-radio .address .btn:not(:first-of-type) {
    margin: 0 10px 0px 45px;
  }
  .header-radio .address .btn {
    &:nth-child(2) {
      margin-left: 55px;
    }
  }

  /*::v-deep .pagination-text{
    display: none;
  }
  ::v-deep .pagination-jump{
    display: none;
  }*/
  .policy-cash-list{
    width: 94%;
    height: 500px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    .scroll-list-th{
      width: 100%;
      height: 40px;
      margin: 0;
      li{
        width: 100%;
        display: flex;
        span{
          display: inline-block;
          flex: 1;
          font-size: 14px;
          &:nth-child(1){
            flex: 3;
          }
          &:nth-child(2){
            flex: 2.5;
          }
          &:nth-child(3){
            flex: 2;
          }
        }
      }
    }
    .policy-scroll{
      width: 100%;
      height: 450px;
      .seamless-wrap{
        height: 100%;
        overflow: hidden;
        ul{
          margin: 0;
          li{
            width: 100%;
            display: flex;
            margin: 8px 0;
            padding: 12px 0;
            font-size: 14px;
            span{
              display: inline-block;
              flex: 1;
              &:nth-child(1){
                flex: 3;
              }
              &:nth-child(2){
                flex: 2.5;
              }
              &:nth-child(3){
                flex: 2;
              }
            }
            &:nth-child(2n){
              background-color: #f7f7f7;
            }

          }
        }
      }
    }
  }
  #echartsBar {
    width: 85%;
    height: 500px;
    margin: 40px auto;
  }
  .iframe-div {
    width: 100%;
    height: 1400px;
    margin-top: 20px;
    .top-center {
      line-height: 2;
      text-indent: 25px;
    }
    .iframe-container {
      width: 100%;
      height: 100%;
    }
  }
    .contacts-item {
      margin-top: 20px;
      span {
        margin-right: 20px;
        line-height: 28px;
        font-size: 14px;
        color: #333;
        i {
          font-size: 20px;
          color: #999;
          margin-right: 5px;
        }
      }
    }
    li {
      list-style: none;
    }
    .banner {
      width: 100%;
      margin: 10px auto 35px;
    }
    ::v-deep .el-radio-button {
      margin: 0 10px 5px;
      .el-radio-button__inner {
        border-radius: 14px;
        padding: 7px 12px;
        border: none;
      }
    }
    .area {
      padding-bottom: 10px;
      border-bottom: 1px solid rgba(229, 229, 229, 1);
    }
    .form-item {
      padding-top: 15px;
      overflow: hidden;
      .form-item-label {
        font-size: 14px;
        width: 70px;
        float: left;
      }
      ::v-deep .el-radio-group {
        float: left;
        width: calc(100% - (80px));
        margin-top: -5px;
      }
      ::v-deep {
        .el-input__inner {
          height: 32px;
          line-height: 32px;
        }
        .el-date-editor {
          .el-range__icon {
            line-height: 24px;
          }
          .el-range-separator {
            padding: 0 0px;
            line-height: 24px;
          }
        }
      }
    }
    .form-search {
      // display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 15px;
      padding: 15px 0px 0 0;
      border-bottom: 1px solid rgba(229, 229, 229, 1);
      height: 65px;
      .form-search-left {
        display: flex;
        justify-content: space-between;
        align-items: center;
        float: right;
        overflow: hidden;
        /*span {
          width: 110px;
          height: 40px;
          line-height: 40px;
          color: rgba(80, 80, 80, 1);
          display: block;
          font-size: 18px;
          font-weight: bold;
        }*/
        .el-input {
          width: 70%;
        }
        .el-input__inner {
          width: 150px;
          height: 40px;
          line-height: 40px;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          border: none;
          background: #f1f2f3;
        }
        .el-button {
          padding: 11px 15px;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
          background-color: #409eff;
          border-color: #409eff;
          span{
            color: #ffffff;
          }
        }
      }
      .el-tabs__active-bar {
        display: none;
      }
      .el-tabs__nav-wrap::after {
        height: 0px;
      }
      .el-tabs__header {
        margin-bottom: 0px;
      }
    }
    .table {
      width: 100%;
      .item {
        display: flex;
        padding: 20px;
        cursor: default;
        .left-box {
          flex: 1;
          overflow: hidden;
          .title-box {
            width: 90%;
            display: flex;
            margin-bottom: 16px;
            align-items: center;
            .tit {
              line-height: 24px;
              // flex: 1;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-weight: 700;
              max-width: calc(100% - 100px);
            }
            .status-icon {
              width: 24px;
              height: 24px;
              margin: 0;
              margin-right: 10px;
            }
            .new_icon {
              height: 18px;
              margin-left: 10px;
              margin-top: 2px;
            }
            .status-text {
              padding: 0 6px;
              line-height: 24px;
              background: #e5e5e5;
              border-radius: 4px;
              margin-right: 16px;
              font-size: 14px;
              &.ended {
                background: #ce2a2a;
                color: #fff;
              }
              &.doing {
                background: #df4a42;
                color: #fff;
              }
            }
          }
          .type-box {
            display: flex;
          }
          .time-box {
            display: flex;
            margin-top: 20px;
          }
          .item-icon {
            margin: 0;
            width: 16px;
            height: 16px;
            margin-right: 8px;
            margin-top: 5px;
          }
          .text {
            line-height: 28px;
            font-size: 14px;
            color: #333;
            margin-right: 8px;
          }
        }
        .right-box {
          flex: 1;
          display: flex;
          justify-content: space-between;
          .amount-box {
            width: 530px;
            overflow: hidden;
            text-overflow: ellipsis;
            padding-right: 30px;
            .content-html {
              width: 100%;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              word-break: break-all;
              white-space: pre-wrap;
              overflow: hidden;
              cursor: pointer;

              p {
                line-height: 1.8;
              }
            }
          }
          .lin_60 {
            line-height: 60px;
            display: flex;
            text-align: center;
            justify-content: center;
          }
          .label {
            margin-top: 20px;
            font-size: 14px;
            color: #333;
            line-height: 40px;
            text-align: center;
          }
          .unit {
            margin-left: 10px;
            margin-top: 26px;
            box-sizing: border-box;
            line-height: 16px;
            height: 30px;
            font-size: 14px;
            color: #333;
          }
          .fs_28 {
            font-size: 28px;
          }
          .numText {
            color: #e39038;
          }
          .red-text {
            color: red;
            line-height: 20px;
            height: 20px;
            font-size: 12px;
            margin-top: 10px;
            text-align: center;
          }
          .btns {
            margin-top: 30px;
          }
          .btn {
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding-top: 10px;
            span {
              margin-top: 15px;
              i {
                margin: 0 10px;
                font-size: 18px;
                font-weight: bold;
                font-style: normal;
              }
            }
          }
          .btns {
            /deep/ .el-button--text {
              font-size: 14px;
              & + .el-button {
                margin-left: 16px;
                position: relative;
                &::before {
                  position: absolute;
                  content: "";
                  width: 0;
                  height: 14px;
                  left: -8px;
                  top: 14px;
                  border-left: 1px solid #999999;
                }
              }
            }
          }
        }
      }
      .cash-policy-scroll{
        width: 100%;
        height: 40px;
        .seamless-wrap{
          height: 100%;
          overflow: hidden;
          ul{
            margin: 0;
            li{
              margin: 0;
              padding: 5px 0;
              font-size: 14px;
              span{
                display: inline-block;
                width: 46%;
              }
            }
          }
        }
      }
    }
    .dialog {
      h3 {
        color: rgba(80, 80, 80, 1);
        font-size: 20px;
        text-align: center;
      }
      div {
        padding: 0px 30px;
      }
      div,
      p {
        font-size: 18px;
        color: rgba(80, 80, 80, 1);
        line-height: 3;
      }
      p {
        text-indent: 30px;
      }
    }
    .inquiry-modal {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      background-color: #ffffff;
      z-index: 9999;

      i {
        position: absolute;
        right: 20px;
        top: 17px;
        cursor: pointer;
      }
    }
}

@import "@/assets/styles/components/policyNav.scss";
</style>
